// extracted by mini-css-extract-plugin
export default {"products":"xs-z","card":"ys-z","oosMessaging":"zs-z"};